import React, { Component } from "react";
import { Link } from "react-router";
import { showUserLeaveGroupModal } from "../../actions/mixed";
import { connect } from "react-redux";

class StudyGroupUserNavigation extends Component {
  render() {
    const { tabs, groupId, activeUrl, user } = this.props;

    const getUrl = (url) => `/groups/${groupId}${url}`;

    const isUrlActive = (url) =>
      url.includes("/webinars")
        ? activeUrl.includes("/webinars")
        : activeUrl.includes(url);

    const isUser = user.role === "user";

    const isMembersPage = activeUrl.includes("/members");

    const showLeaveGroup = isUser && isMembersPage;

    return (
      <div className="group-navigation" style={{ position: "relative" }}>
        {tabs.map(({ label, url }, idx) => {
          return (
            <Link
              className={`group-navigation-button ${
                isUrlActive(url) ? "active" : ""
              }`}
              to={getUrl(url)}
              key={idx}
            >
              {label}
            </Link>
          );
        })}
        {showLeaveGroup && (
          <a
            className="button_link"
            style={{ textAlign: "center" }}
            onClick={() => this.props.showModal()}
          >
            Leave Group
          </a>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.users.user,
});

const mapDispatchToProps = (dispatch) => ({
  showModal: (payload) => dispatch(showUserLeaveGroupModal(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupUserNavigation);



// WEBPACK FOOTER //
// ./src/components/StudyGroupsUser/StudyGroupUserNavigation.jsx